<div id="managespladetails" class="subBlockContainer managesubscriptiondetails">
  <child-header [title]="vendorAgreementNo" (closeEvent)="close()"></child-header>
  <div #ParentWrapper class="subBlockContent">
    <div class="title-wrapper">
      <div class="page-title-wrapper">
        <div class="page-title-position">
          <img class="page-title-img" [attr.src]="details?.annuityType?.logo" [class.adjust-logo-size]="programType === 'CISCO' || programType === 'CISCOSAAS'">
        </div>

        <!-- <div class="downloadButton buttonGroup" placement="bottom" ngbTooltip="Download Price File"
(click)="downloadPriceFile(details?.annuityType?.salesType)">

</div>
<div *ngIf="details?.annuityType?.moreInfoLink" class="moreButton buttonGroup"
(click)="onNavigate(details?.annuityType?.moreInfoLink)" target="_blank" placement="bottom" ngbTooltip="More">
</div> -->
      </div>
    </div>
    <div class="item-title-wrapper">
      <!-- <div class="page-title-wrapper">
          <div class="page-title-position">
              <label class="page-title-lable"> {{vendorAgreementNo}} </label>
              <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
              <img class="page-title-img" [src]="details?.annuityType?.logo" [class.adjust-logo-size]="programType === 'CISCO' || programType === 'CISCOSAAS'">
          </div>
      </div> -->
      <!-- <div class="downloadButton buttonGroup" placement="bottom" ngbTooltip="Download Price File"
(click)="downloadPriceFile(details?.annuityType?.salesType)">

</div>
<div *ngIf="details?.annuityType?.moreInfoLink" class="moreButton buttonGroup"
(click)="onNavigate(details?.annuityType?.moreInfoLink)" target="_blank" placement="bottom" ngbTooltip="More">
</div> -->


      <!-- <div class="row filter-wrapper" style="margin-top: -25px;">
<div class="col-md-10 long-description">
<small style="font-size:9px;">{{ details?.annuityType?.longDescription }}</small>&nbsp;

</div>
<div class="col-md-2 small-logo">
<img [src]="details?.annuityType?.logo">
</div>
</div> -->
      <!-- <div class="row" style="padding-left:88%">
<div class="downloadButton buttonGroup" placement="top" ngbTooltip="Download Price File"
(click)="downloadPriceFile(details?.annuityType?.salesType)"></div>&nbsp;
<a *ngIf="details?.annuityType?.moreInfoLink" class="moreButton buttonGroup"
[href]="details?.annuityType?.moreInfoLink" target="_blank" placement="top" ngbTooltip="More"></a>&nbsp;
</div> -->

      <!-- <div class="top-divider"></div> -->

      <div *ngIf="loadContent && details?.annuityType">
        <div class="wrapper center-block">
          <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingOne">
                <h4 class="panel-title">
                  <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                    ANNUITY DETAILS
                    <span class="panel-subtitle" id="panelsubtitle">
                      <label class="lable-title">ENROLMENT NO:&nbsp;</label> <span>{{ vendorAgreementNo }}</span>
                      <label class="lable-title">| ANNUITY END:&nbsp;</label> <span>{{ details?.annuityEnd }}</span>
                      <span class="triangle-down"></span>
                    </span>

                  </a>
                </h4>
                <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                  <div class="panel-body">
                    <div class="panel-content">
                      <div class="row">
                        <div class="col-sm">
                          <label class="lable-title">PREVIOUS CUSTOMER REF</label>
                          <p class="paragraph-text">{{ details?.currCustomerRef }}</p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">ANNUITY START</label>
                          <p class="paragraph-text">{{ details?.annuityStart }} </p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">ANNUITY END</label>
                          <p class="paragraph-text">{{ details?.annuityEnd }}</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm">
                          <label class="lable-title">PREVIOUS INVOICE NO</label>
                          <p class="paragraph-text">{{ details?.lastInvoiceNo }}</p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">ENROLMENT NO</label>
                          <p class="paragraph-text">{{ details?.agreementNumber }}</p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">REPORTING FREQUENCY</label>
                          <p class="paragraph-text">{{ details?.frequency}}</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm">
                          <label class="lable-title">PREVIOUS INVOICE VALUE (ex GST)</label>
                          <p class="paragraph-text">{{ details?.lastValue }}</p>
                        </div>
                        <div class="col-sm">
                          <label class="lable-title">PREVIOUS USAGE MONTH</label>
                          <p class="paragraph-text">{{ details?.currUsageMonth }}</p>
                        </div>
                        <div class="col-sm">

                        </div>
                      </div>

                      <!-- Paymen Detail Section-->
                      <app-subscription-payment-detail [paymentMethod]="paymentMethod"></app-subscription-payment-detail>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div *ngIf="loadContent && details?.annuityType">
        <div class="wrapper center-block margin-t-x10">
          <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingOne">
                <h4 class="panel-title">
                  <a role="button">
                    NEW ANNUITY DETAILS
                  </a>
                </h4>
                <div class="panel-collapse collapse in show" role="tabpanel" aria-labelledby="headingOne">
                  <div class="panel-body">
                    <div class="panel-content">
                      <div class="row">
                        <div class="col-sm">
                          <span class="lable-title">NEW CUSTOMER REF:&nbsp;</span>
                          <span class="small-text" *ngIf="readOnly">{{ details?.nextCustomerRef }}</span>
                          <input type="text" *ngIf="!readOnly" class="input-box sub-ref small-text" [(ngModel)]="details.nextCustomerRef" />
                        </div>
                        <div class="col-sm">
                          <span class="lable-title">NEW USAGE MONTH:&nbsp;</span>
                          <span class="small-text"> {{ details?.nextUsageMonth }}</span>
                        </div>
                        <div class="col-sm">
                          <span class="lable-title">ANNUITY STATUS:&nbsp;</span>
                          <span class="statusLabel small-text" [class.bgcolor-green]="details?.annuityStatus=='Confirmed'">{{ details?.annuityStatus }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div *ngIf="loadContent && !details?.annuityType">
        <div class="wrapper center-block margin-t-x10">
          <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingOne">
                <div class="panel-body">
                  <div class="panel-content">
                    <div class="no-subs-panel">
                      <div>
                        <img src="../../images/new_ui/no-subscription.png">
                      </div>
                      <label class="no-subs-label">
                        We couldn’t find any annuity data for your account
                      </label>
                      <br />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div *ngIf="loadContent && details?.annuityType">
        <div class="wrapper center-block margin-t-x10">
          <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingOne">
                <div class="panel-body">
                  <div class="panel-content">
                    <div style="margin-top: 0px;" *ngIf="!nextItemDetails?.length">
                      <div class="noData-wrapper">
                        <div>
                          <img src="../../images/new_ui/no-subscription.png">
                        </div>
                        <label class="noData-label">
                          We couldn't find any <br />
                          items for this order
                        </label>
                        <br />
                        <div *ngIf="details?.puchaseAccess == 'Y'">
                          <button 
                            class="button button-red button-large"
                            (click)="getSubscriptionList();"
                          >Add items</button>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="nextItemDetails?.length">
                      <div class="mTable-header">
                        <div style="padding: 20px 0;" class="filter-wrapper">
                          <div class="searchInputGroup push-left">
                            <div class="searchIcon">
                              <img src="../../images/new_ui/filter.png">
                            </div>
                            <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="searchField">
                          </div>
                        </div>
                      </div>
                      <div class="mTable">
                        <table class="table display-block">
                          <thead>
                          <tr>
                            <!-- <th *ngIf="showEndUser" scope="col" style="width: 10%">ENROLMENT NO</th> -->
                            <th scope="col" style="width: 3%;"></th>
                            <th scope="col" style="width: 10%">SKU</th>
                            <th scope="col" [ngClass]="{'wide-des': !showEndUser}" style="width: 45%">DESCRIPTION</th>
                            <th scope="col" class="align-center" style="width: 12%">LAST ORDER QTY</th>
                            <th scope="col" class="align-center" style="width: 10%">QTY</th>
                            <th scope="col" class="align-center" style="width: 12%">UNIT PRICE (Ex)</th>
                            <th scope="col" class="align-center" style="width: 13%">TOTAL (Ex)</th>
                          </tr>
                          </thead>
                          <tbody>
                          <ng-container *ngFor="let item of nextItemDetails | TableFilterMultiple: ['out_line_description', 'out_stock_code','out_line_price'] : searchField; index as i">
                            <tr [attr.id]="item.out_stock_code + i">
                              <td>
                                <div class="align-center">
                                  <button
                                    class="button button-red button-mid button-hover-white"
                                    [disabled]="readOnly || (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)"
                                    [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                                    matTooltip="Requires Purchasing Permissions"
                                    (click)="removeCurrentItem(item)"
                                  >
                                    Remove
                                  </button>
                                </div>
                              </td>
                              <td>
                                {{ item.out_stock_code }}
                              </td>
                              <td>{{ item.out_line_description }}
                                <div *ngIf="!readOnly">
                                  <br>
                                  <span class="infoSection-title-bold">END USER:&nbsp;</span>
                                  <input type="text" class="input-box sub-ref euInput" [attr.id]="'euinput' + item.out_stock_code + i" [(ngModel)]="item.out_display_name" (ngModelChange)="onEndUserChange(item)" />&nbsp;
                                  <div class="button button-red button-mid" *ngIf="item.needUpdate" ngbTooltip="Save End User" (click)="saveEndUser(item, i)" style="padding-top: 2.5px;">SAVE</div>
                                </div>
                              </td>
                              <td class="align-center">{{ item.currentQty }}</td>
                              <td class="align-center" style="position: relative;vertical-align: top;">
                                <div>
                                  <!-- <div class="qty-minus-sign button-red" [class.disableMinus]="item.out_line_qty == '0'"
        (click)="increaseDecreaseQty(item, i, 'decrease')">
        <i class="fas fa-minus-square fa-2x"></i>
      </div> -->
                                  <input 
                                    integerOnly 
                                    [attr.id]="'input' + item.out_stock_code + i" 
                                    type="text" 
                                    class="input-box-small" 
                                    [ngModel]="item.out_line_qty" 
                                    (focusout)="onQtyChange(item, $event.target.value, i)" 
                                    #qtyInput 
                                    [disabled]="readOnly || (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)"
                                    [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                                    matTooltip="Requires Purchasing Permissions"
                                  />
                                  <!-- <div class="qty-plus-sign button-red" (click)="increaseDecreaseQty(item, i, 'increase')">
        <i class="fas fa-plus-square fa-2x"></i>
      </div> -->
                                </div>
                                <!-- <div *ngIf="details?.puchaseAccess !== 'Y'">
                                  <label>{{ item.out_line_qty }}</label>
                                </div> -->
                              </td>
                              <td class="align-right">{{ item.out_line_price | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</td>
                              <td class="align-right">{{ item.out_line_amount_ex | currency:'AUD':'symbol-narrow':'.2-2' }}/mth
                              </td>
                            </tr>
                          </ng-container>
                          </tbody>
                          <tfoot>
                          <div class="row totalPrice-wrapper">
                            <div class="col align-center">

                            </div>
                            <div class="col align-center">
                                                        <span><b>TOTAL (Ex GST) </b> <span
                                                          style="font-size: 18px;">{{ totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                            </div>
                          </div>
                          </tfoot>
                        </table>
                      </div>
                      <div class="row">
                        <div class="col button-center">
                          <button
                            class="button button-red button-large button-center-left"
                            [disabled]="readOnly || (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)"
                            [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                            matTooltip="Requires Purchasing Permissions"
                            (click)="getSubscriptionList();"
                          >
                            Add items
                          </button>
                          <button 
                            class="button button-red button-large button-center-right"
                            [disabled]="readOnly || (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)"
                            [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                            matTooltip="Requires Purchasing Permissions"
                            (click)="confirmAnnuity()"
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="true" [scrollAfterLoading]="true"></loading-screen>

    <!-- Modal -->
    <!-- <div class="modal fade" id="addNewsplaSubscriptionModdal" tabindex="-1" role="dialog" aria-labelledby="modalLabel"
aria-hidden="true">
<div class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="modalLabel">Add items for order</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row filter-wrapper" style="margin-left: 12px;">
        <div class="col-md-4">
          <div class="searchInputGroup">
            <div class="searchIcon">
              <img src="../../images/new_ui/filter.png">
            </div>
            <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="searchOrder">
          </div>
        </div>
      </div>
      <table class="table list-table description-table tbModal" style="width: auto;">
        <thead>
          <tr>
            <th scope="col" style="width:60%">DESCRIPTION</th>
            <th scope="col" class="align-center" style="width:15%">PRICE</th>
            <th scope="col" class="align-center" style="width:15%">QTY</th>
            <th scope="col" class="align-center" style="width:10%"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of newItemsList | TableFilterMultiple: ['description', 'stockCode'] : searchOrder">
            <td style="position:relative" class="description-td">
              <span class="description">{{item?.description}}</span>
              <div class="result-info">
                <div class="produc-secondary-title-wrapper">
                  <span class="light-text">STOCK CODE:&nbsp;</span>
                  <span>{{item?.stockCode}}</span>
                </div>
              </div>
            </td>
            <td class="align-center">{{item?.itemPrice}}/mth</td>
            <td class="align-center"><input integerOnly type="text" class="input-box-small" value="1"
                #orderquantity /></td>
            <td class="align-center">
              <button class="button button-red button-small"
                [ngClass]="{'disable bgcolor-green': item.isAdded}"
                (click)="addAnnuityItem(item, orderquantity.value);">Add<span
                  *ngIf="item.isAdded">ed</span></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div> -->
    <modal-popup [modalTitle]="modalDetails.title" [modalContent]="modalDetails.content"></modal-popup>
  </div>

  <!-- create the add new item table in the same component -->
  <!-- <div class="subBlockContainer" *ngIf="showNewSubscription" style="width: 800px;">
<div class="subBlockContent">
  <div class="page-title-wrapper">
    <div title blade-title-font>
        Add items for order
    </div>
    <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
  </div>
  <div class="inner-subBlock-wrapper">
    <table class="table description-table tbModal" style="width: auto;">
      <thead>
        <tr>
          <th scope="col" style="width:60%">DESCRIPTION</th>
          <th scope="col" class="align-center" style="width:15%">PRICE</th>
          <th scope="col" class="align-center" style="width:15%">QTY</th>
          <th scope="col" class="align-center" style="width:10%"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of newItemsList | TableFilterMultiple: ['description', 'stockCode'] : searchOrder">
          <td style="position:relative" class="description-td">
            <span class="description">{{item?.description}}</span>
            <div class="result-info">
              <div class="produc-secondary-title-wrapper">
                <span class="light-text">STOCK CODE:&nbsp;</span>
                <span>{{item?.stockCode}}</span>
              </div>
            </div>
          </td>
          <td class="align-center">{{item?.itemPrice}}/mth</td>
          <td class="align-center"><input integerOnly type="text" class="input-box-small" value="1"
              #orderquantity /></td>
          <td class="align-center">
            <button class="button button-red button-small"
              [ngClass]="{'disable bgcolor-green': item.isAdded}"
              (click)="addAnnuityItem(item, orderquantity.value);">Add<span
                *ngIf="item.isAdded">ed</span></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div> -->
</div>

<router-outlet></router-outlet>
